import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaMousePointer, FaCalendarAlt, FaPlayCircle } from "react-icons/fa";
import learnQuran from "../../assets/start-learing.webp";
import "./FourthSection.css";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const steps = [
  {
    icon: <FaMousePointer size={22} color="#fff" />,
    number: "01",
    title: "One Click Registration",
    desc: (
      <>
        Simply{" "}
        <a
          href="#"
          className="fs-link"
          onClick={(e) => {
            e.preventDefault();
            scrollTo("home");
          }}
        >
          click here
        </a>{" "}
        to reach the registration page. Fill in your name and contact info to
        sign up for free online Quran classes instantly.
      </>
    ),
    accent: "#1d6fc4",
  },
  {
    icon: <FaCalendarAlt size={22} color="#fff" />,
    number: "02",
    title: "Schedule Free Trial",
    desc: "We'll reach out to set a convenient time for your free trial class and walk you through our teaching process.",
    accent: "#0ea5e9",
  },
  {
    icon: <FaPlayCircle size={22} color="#fff" />,
    number: "03",
    title: "Start Your First Class",
    desc: "Log in to the Student Portal with your credentials and begin learning with one of our expert online Quran teachers.",
    accent: "#0d9488",
  },
];

const cardVariants = {
  hidden: { opacity: 0, x: -30 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: { delay: i * 0.15, duration: 0.5, ease: "easeOut" },
  }),
};

const FourthSection = () => {
  return (
    <section className="fs-section">
      <Container>
        <Row className="align-items-center">
          {/* Left: Text + Steps */}
          <Col lg={6} className="mb-5 mb-lg-0">
            <span className="fs-eyebrow">Get started</span>
            <h2 className="fs-title">
              Start Learning Quran <br />
              <span className="fs-title-accent">in 3 Easy Steps</span>
            </h2>
            <p className="fs-desc">
              Register yourself or your child today and take your first free
              trial class — no commitment required.
            </p>

            <div className="fs-steps">
              {steps.map((step, idx) => (
                <motion.div
                  key={idx}
                  className="fs-card"
                  custom={idx}
                  variants={cardVariants}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
                  {/* Left accent bar */}
                  <div
                    className="fs-card-bar"
                    style={{ background: step.accent }}
                  />

                  {/* Icon circle */}
                  <div
                    className="fs-icon"
                    style={{ background: step.accent }}
                  >
                    {step.icon}
                  </div>

                  {/* Content */}
                  <div className="fs-card-body">
                    <span className="fs-step-num">{step.number}</span>
                    <h3 className="fs-card-title">{step.title}</h3>
                    <p className="fs-card-text">{step.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </Col>

          {/* Right: Image */}
          <Col lg={6} className="text-center">
            <motion.div
              className="fs-image-wrap"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              viewport={{ once: true }}
            >
              <img
                src={learnQuran}
                alt="Learn Quran online"
                className="fs-image"
              />
              <div className="fs-image-blob" />
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FourthSection;